<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">{{ locale.cities }}</h4>
        <div
            class="col-12 text-right"
            style="margin-bottom: 10px; margin-top: -50px"
        >
          <n-button
              type="primary"
              class="btn btn-sm btn-primary"
              @click.native="onAddCity()"
          >
            <span>{{ locale.add_city }}</span>
          </n-button>
        </div>
        <div>
          <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          ></div>
          <el-table stripe style="width: 100%" :data="cities">
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
            >
            </el-table-column>

            <el-table-column :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >
                <el-tooltip content="Edit" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onEditCity(row.id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons ui-2_settings-90"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onDeleteCity(row.id)"
                      class="remove"
                      type="danger"
                      size="sm"
                      round
                      icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <modal name="add-city" :adaptive="true" :resizable="true" :minHeight="200">
          <div style="text-align: center; margin: 1em">
            <n-button
                @click.native="onModalHide('add-city')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <input v-model="new_city_name" v-bind:placeholder="locale.city_name + '*'">
            <br>
            <br>
            <span>{{ locale.select_country }}:* </span>
            <select v-model="city_selected_country">
              <option v-for="country in countries" v-bind:value="country.id" v-bind:key="country.id">{{country.value}}</option>
            </select>
            <br>
            <br>
            <n-button
                type="primary"
                class="btn btn-sm btn-primary"
                @click.native="addCity()"
            >
              <span>{{ locale.add_city }}</span>
            </n-button>
          </div>


        </modal>
        <modal name="update-city" :adaptive="true" :resizable="true" :minHeight="200">
          <div style="text-align: center; margin: 1em">
            <n-button
                @click.native="onModalHide('update-city')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <input v-model="new_city_name" v-bind:placeholder="locale.city_name + '*'">
            <br>
            <br>
            <span>{{ locale.select_country }}:* </span>
            <select v-model="city_selected_country">
              <option v-for="country in countries" v-bind:value="country.id" v-bind:key="country.id">{{country.value}}</option>
            </select>
            <br>
            <br>
            <n-button
                type="primary"
                class="btn btn-sm btn-primary"
                @click.native="updateCity()"
            >
              <span>{{ locale.update_city }}</span>
            </n-button>
          </div>
        </modal>
        <div slot="footer" class="card-footer d-flex justify-content-end">
          <n-pagination class="pagination-no-border" :total="total">
          </n-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination as NPagination } from "src/components";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    NPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      locale: '',
      total: 0,
      cities: [],
      countries: [],
      tableColumns: [
        {
          prop: "id",
          label: this.$getLocale().id,
          minWidth: 250,
        },
        {
          prop: "value",
          label: this.$getLocale().city_name,
          minWidth: 250,
        },
        {
          prop: "country_name",
          label: this.$getLocale().country_name,
          minWidth: 250,
        },
      ],
      new_city_name: '',
      city_selected_country: '',
      upd_city_id: '',
    };
  },

  methods: {
    onModalHide(name) {
      this.$modal.hide(name);
    },
    onAddCity() {
      this.new_city_name = '';
      this.city_selected_country = '';
      this.$modal.show('add-city');
    },

    async addCity() {
      let user_data = {
        'name': this.new_city_name,
        'country_id': this.city_selected_country,
      };
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/add-city", requestOptions)
          .then(response => this.getCities());
      this.$modal.hide('add-city');
    },

    onEditCity(id) {
      this.upd_city_id = id;
      let updating_city = this.cities.filter(elem => elem.id == id)[0];

      this.new_city_name = updating_city.value;
      this.city_selected_country = updating_city.country_id;
      this.$modal.show('update-city');
    },

    async updateCity() {
      let user_data = {
        'name': this.new_city_name,
        'country_id': this.city_selected_country,
        'id': this.upd_city_id,
      };
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/update-city", requestOptions)
          .then(response => this.getCities());
      this.$modal.hide('update-city');
    },

    async onDeleteCity(id) {
      let user_data = {
        'id': id,
      };
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/delete-city", requestOptions)
          .then(response => this.getCities());
    },


    async getCities() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({ title: 'Vue POST Request Example' })
      };
      fetch(url + '/list-cities', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.cities = data;
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getCountries() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-countries', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.countries = data;
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    }
  },

  created() {
    this.getCities();
    this.getCountries();
  },
  mounted() {
    this.locale = this.$getLocale();
  },
};
</script>
<style scoped>
.card-body .vm--container{
  z-index: 9999999;
}
.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}
</style>
